import { NFCeImprimir } from "src/services/Fiscal.Service";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { showToast } from "src/componentes";
import { MenuItemAction } from "../../Menu/MenuItem.Dto";

type NFCeMenuCodeProps = {
  nfceId: number;
  setDescricaoProdutoConsulta: React.Dispatch<React.SetStateAction<string>>;
};

const NFCeMenuCode = (props: NFCeMenuCodeProps) => {
  const navigate = useNavigate();

  const reimprimirDanfe = () => {
    if (props.nfceId > 0) {
      imprimirDanfe(props.nfceId);
    } else {
      showToast({
        message: "Nenhuma nfce emitida.",
        title: "Info",
        variant: "Info",
      });
    }
  };

  const handleMenuAlterarNumeroClick = () => {
    const input = prompt("Digite um número inteiro:");

    if (input !== null) {
      const valor = parseInt(input, 10);

      if (!isNaN(valor)) {
        localStorage.setItem("nfceAlterarNumero", valor.toString());
        props.setDescricaoProdutoConsulta("Próxima NFCe com número: " + valor);
      } else {
        alert("Valor inválido! Por favor, digite um número inteiro.");
      }
    } else {
      console.log("Entrada cancelada pelo usuário.");
    }
  };

  const menuPrincipal: MenuItemAction[] = [
    {
      id: 1,
      nome: "Reimprimir Danfe",
      rota: "",
      sequencia: 1,
      nivel: 1,
      idNivelAnterior: 0,
      action: reimprimirDanfe,
    },
    {
      id: 2,
      nome: "Consulta",
      rota: "/fiscal/nfce/consulta",
      sequencia: 2,
      nivel: 1,
      idNivelAnterior: 0,
    },
    {
      id: 3,
      nome: "Ferramentas ...",
      rota: "",
      sequencia: 3,
      nivel: 1,
      idNivelAnterior: 0,
      children: [
        {
          id: 3,
          nome: "Alterar Número NFCe",
          rota: "",
          sequencia: 1,
          nivel: 2,
          idNivelAnterior: 3,
          action: handleMenuAlterarNumeroClick,
        },
      ],
    },
  ];

  const imprimirDanfe = async (id: number) => {
    const response = await NFCeImprimir(id);
    const pdfBlob = new Blob([response.data], { type: "application/pdf" });
    const pdfURL = URL.createObjectURL(pdfBlob);
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfURL;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow?.print();
    };
  };

  const [menuItens, setMenuItens] = useState<MenuItemAction[]>(menuPrincipal);

  const handleMenuClick = (item: MenuItemAction) => (e: React.MouseEvent) => {
    if (item.children && item.children.length > 0) {
      e.stopPropagation();
      setMenuItens(item.children);
    } else if (item.action) {
      item.action();
    } else if (item.rota) {
      navigate(item.rota);
    }
  };

  const handleMenuToggleClick = (isOpen: boolean) => {
    if (!isOpen) {
      setMenuItens(menuPrincipal);
    }
  };

  return { imprimirDanfe, handleMenuClick, handleMenuToggleClick, menuItens };
};
export default NFCeMenuCode;
